"use strict";
/**
 * Copyright © 2019 - Present, VamStar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLegendMarkerColor = void 0;
const enums_1 = require("@vamstar/fox-api-common/esm/common/enums");
/**
 * Gets the legend color properties based on legend enum
 * @param legendEnum - Enum of LegendMarker
 * @returns color properties
 */
exports.getLegendMarkerColor = (legendEnum) => {
    switch (legendEnum) {
        case enums_1.LegendMarkerEnum.MISSED:
            return { color: 'black', shade: 'light' };
        case enums_1.LegendMarkerEnum.OPEN:
            return { color: 'tertiary', shade: 'dark' };
        case enums_1.LegendMarkerEnum.ENDING:
            return { color: 'reds', shade: 'main' };
        case enums_1.LegendMarkerEnum.RECURRING:
            return { color: 'yellows', shade: 'main' };
        default:
            return { color: 'tertiary', shade: 'dark' };
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9sZWdlbmRzL3V0aWxzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7Ozs7O0dBTUc7OztBQUVILG9FQUE0RTtBQUk1RTs7OztHQUlHO0FBQ1UsUUFBQSxvQkFBb0IsR0FBRyxDQUFDLFVBQTRCLEVBQXNCLEVBQUU7SUFDdkYsUUFBUSxVQUFVLEVBQUU7UUFDbEIsS0FBSyx3QkFBZ0IsQ0FBQyxNQUFNO1lBQzFCLE9BQU8sRUFBRSxLQUFLLEVBQUUsT0FBTyxFQUFFLEtBQUssRUFBRSxPQUFPLEVBQUUsQ0FBQztRQUM1QyxLQUFLLHdCQUFnQixDQUFDLElBQUk7WUFDeEIsT0FBTyxFQUFFLEtBQUssRUFBRSxVQUFVLEVBQUUsS0FBSyxFQUFFLE1BQU0sRUFBRSxDQUFDO1FBQzlDLEtBQUssd0JBQWdCLENBQUMsTUFBTTtZQUMxQixPQUFPLEVBQUUsS0FBSyxFQUFFLE1BQU0sRUFBRSxLQUFLLEVBQUUsTUFBTSxFQUFFLENBQUM7UUFDMUMsS0FBSyx3QkFBZ0IsQ0FBQyxTQUFTO1lBQzdCLE9BQU8sRUFBRSxLQUFLLEVBQUUsU0FBUyxFQUFFLEtBQUssRUFBRSxNQUFNLEVBQUUsQ0FBQztRQUM3QztZQUNFLE9BQU8sRUFBRSxLQUFLLEVBQUUsVUFBVSxFQUFFLEtBQUssRUFBRSxNQUFNLEVBQUUsQ0FBQztLQUMvQztBQUNILENBQUMsQ0FBQyJ9